import { object } from '@hapi/joi';
import { CommonGet, CommonPost } from '../../../utils/CommonFetch';
import tokenDecoder from '../../../components/Common/tokenDecoder';

export default {
    saveData,
    getAll,
    editData,
    getFactories,
    getGroups,
    getEstates,
    getCollectionPoints,
    getDeductionTypes,
    getApplyMethods,
    getCollectionPointCategories,
    getOperationalEntityByGroupEntityID,
    getEntityTypes,
    getCollectionPointByGroupEntityID,
    getDeductionTypesByGroupEntityID,
    getAllByFilter,
    getAvailableDeductionTypes,
    getCollectionPointByOperationEntityId,
    getAllOperationEntitiesForDropDown,
     getCollectionCategoryMenusForDropdown,
    getDeductionDataForAddEdit
};

async function saveData(data,fixedValues) {
    let deduction = {
        deductionTemplateID: 0,
        groupID: parseInt(data.groupID),
        operationEntityID: parseInt(data.operationEntityID),
        collectionPointID: parseInt(data.collectionPointID),
        collectionCategoryMenuID: parseInt(data.collectionCategoryMenuID),
        deductionTypeID: parseInt(data.deductionTypeID),
        applyMethodID: parseInt(data.applyMethodID),
        defaultValue: parseFloat(data.defaultValue),
        minimumValue: parseFloat(data.minimumValue),
        createdBy: parseInt(tokenDecoder.getUserIDFromToken()),
        createdDate: new Date().toISOString(),
        modifiedBy: 0,
        modifiedDate: new Date().toISOString(),
        isFixed:data.isFixed,
        isActive: data.isActive,
        isDefaultValueEnabled: data.isDefaultValueEnabled,
        fixedDeductions: fixedValues,
        deductionOrder: parseInt(data.deductionOrder),
        deductionSequence: parseInt(data.deductionSequence)

    }
    console.log("deduction",deduction)
    var result = await CommonPost('/api/DeductionTemplate/InsertDeductionTemplate', null, deduction);
    
    return result;
}

async function editData(data,fixedValues) {
    let deduction = {
        deductionTemplateID: parseInt(data.deductionTemplateID),
        groupID: parseInt(data.groupID),
        operationEntityID: parseInt(data.operationEntityID),
        collectionPointID: parseInt(data.collectionPointID),
        collectionCategoryMenuID: parseInt(data.collectionCategoryMenuID),
        deductionTypeID: parseInt(data.deductionTypeID),
        applyMethodID: parseInt(data.applyMethodID),
        defaultValue: parseFloat(data.defaultValue),
        minimumValue: parseFloat(data.minimumValue),
        createdBy: 0,
        createdDate: new Date().toISOString(),
        modifiedBy: parseInt(tokenDecoder.getUserIDFromToken()),
        modifiedDate: new Date().toISOString(),
        isFixed:data.isFixed,
        isActive: data.isActive,
        isDefaultValueEnabled: data.isDefaultValueEnabled,
        fixedDeductions: fixedValues,
        deductionOrder: parseInt(data.deductionOrder),
        deductionSequence: parseInt(data.deductionSequence)
    }
    var result = await CommonPost('/api/DeductionTemplate/UpdateDeductionTemplate', null, deduction);
    return result;
}


async function getAll() {
    var response = await CommonGet('/api/DeductionTemplate/GetAllDeductionTemplates', null);
    return response.data;
}


async function getGroups() {
    let response = await CommonGet('/api/Group/GetAllGroups', null);
    let groupArray = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function getFactories() {
    var factoryArray = []
    const response = await CommonGet('/api/OperationEntity/GetAllOperationEntities', null)
    return response.data;
}

async function getCollectionPoints() {
    var response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    return response.data;
}

async function getEstates() {
    var response = await CommonGet('/api/Estate/GetAllEstates', null);
    var array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["estateID"]] = item[1]["estateName"]
    }
    return array;
}

async function getApplyMethods() {
    var response = await CommonGet('/api/EnumData/GetApplyMethodEnumData', null);
    var array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["key"]] = item[1]["value"]
    }
    return array;
}


async function getCollectionPointCategories() {
    var response = await CommonGet('/api/EnumData/GetCollectionPointCategoryEnumData', null);

    var array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["key"]] = item[1]["value"]
    }
    return array;
}

async function getDeductionTypes() {
    var response = await CommonGet('/api/DeductionType/GetAllDeductionTypes', null);
    //var array = []
    //for (let item of Object.entries(response.data)) {
    //    if (item[1]["isActive"] === true) {
    //        array[item[1]["deductionTypeID"]] = item[1]["deductionTypeName"]
    //    }
    //}
    return response.data;
}

async function getEntityTypes() {
    let response = await CommonGet('/api/OperationEntity/GetAllEntities', null);
    let array = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            array[item[1]["entityTypeID"]] = item[1]["entityTypeName"]
        }
    }
    return array;
}


async function getOperationalEntityByGroupEntityID(groupID) {
    const response = await CommonGet('/api/OperationEntity/GetOperationEntityByGroupIDEntityID', 'groupID=' + groupID)
    let array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return array;
}

async function getCollectionPointByGroupEntityID(groupID, entityID) {
    const response = await CommonGet('/api/CollectionPoint/GetOperationEntityByGroupIDEntityID', 'groupID=' + groupID + '&entityID=' + entityID)
    let array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
    }
    return array;
}

async function getDeductionTypesByGroupEntityID(groupID, entityID) {
    const response = await CommonGet('/api/DeductionType/GetDeductionTypesByGroupIDEntityID', 'groupID=' + groupID + '&entityID=' + entityID)
    let array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["deductionTypeID"]] = item[1]["deductionTypeName"]
    }
    return array;
}


async function getAllByFilter(groupid, factoryId, collectionPointID) {
    var response = await CommonGet('/api/DeductionTemplate/GetAllDeductionTemplates', 'groupId=' + groupid + '&operationEntityId=' + factoryId + '&collectionPointID=' + collectionPointID);
    return response.data;


}

async function getAvailableDeductionTypes(groupID, factoryID, collectionPointID, deductionTemplateID, collectionCategoryMenuID){
    var deductionTypeArray = [];
    let filterModel = {
        operationEntityID: parseInt(factoryID),
        groupID: parseInt(groupID),
        collectionPointID: parseInt(collectionPointID),
        deductionTemplateID: parseInt(deductionTemplateID),
        collectionCategoryMenuID: parseInt(collectionCategoryMenuID)
    }
    var response = await CommonPost('/api/DeductionType/GetAvailableDeductionTypes', null, filterModel);
    for (let item of Object.entries(response.data)) {
        deductionTypeArray[item[1]["deductionTypeID"]] = item[1]["deductionTypeName"];
    }
    return deductionTypeArray;
}

async function getCollectionPointByOperationEntityId(groupID, operationEntityID) {
    var collectionPointArray = [];
    let filterModel = {
        operationEntityID: operationEntityID.toString(),
        groupID: groupID.toString()
    }
    var response = await CommonPost('/api/CollectionPoint/GetCollectionPointByOperationEntityId', null, filterModel);

    for (let item of Object.entries(response.data)) {
        collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"];
    }

    return collectionPointArray;
}

async function getAllOperationEntitiesForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetOperationEntityByGroupIDEntityID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function getCollectionCategoryMenusForDropdown(collectionPointID){
    var collectionCategoryMenuArray = [];
    var response = 
    await CommonGet('/api/CollectionCategory/GetCollectionCategoryMenuByCollectionPointID', 'collectionPointID=' + collectionPointID);
    for (let item of Object.entries(response.data)){
        collectionCategoryMenuArray[item[1]["collectionCategoryMenuID"]] = item[1]["menuName"];
    }
    return collectionCategoryMenuArray;
}

async function getDeductionDataForAddEdit(id) {
    var response = await CommonGet('/api/DeductionTemplate/GetDeductionTemplateDetailsByID', 'deductionID=' + id);
    return response.data;
}
